import CryptoJS from "crypto-js";
import { api } from "../services/api";
import jwtDecode from "jwt-decode";
import { Redirect, Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import AdminNavbar from "../components/AdminNavbar";
import SuperAdminNavbar from "../components/SuperAdminNavbar";

const storage = window.localStorage;

export const PublicRoute = ({ component: Component, params, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      CheckAuth().status === false ? (
        <div>
          <Component {...props} />
        </div>
      ) : (
        <div>
          <Redirect to={{ pathname: "/dashboard" }} />
        </div>
      )
    }
  />
);

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        CheckAuth().status === true ? (
          <div className="grid-container full" id="maincontainer">
            <div className="grid-x  grid-margin-x" id="rowcontainer">
              {CheckAuth().user === "super_admin" && (
                <SuperAdminNavbar history={props.history} />
              )}
              {CheckAuth().user === "admin" && (
                <AdminNavbar history={props.history} />
              )}

              {CheckAuth().user === "user" && (
                <Navbar history={props.history} />
              )}

              <Component {...props} />
            </div>
          </div>
        ) : (
          <Redirect to="/signin" />
        )
      }
    />
  );
};

export const CheckAuth = () => {
  console.log("Checkauth 1");
  const token = getStorageItem("accessToken");
  const userData = authUserData();

  if (process.env.REACT_APP_SAQ_BYPASS_LOGIN === "true") {
    return {
      user: "admin",
      status: true,
    };
  }

  if (!token) {
    return {
      user: null,
      status: false,
    };
  }

  if (userData && userData.isAdmin) {
    console.log("Checkauth 2");

    return {
      user: "super_admin",
      status: true,
    };
  } else {
    console.log("Checkauth 2");
    const tempBusinessDetails =
      userData &&
      userData.businessDetails &&
      userData.businessDetails.length > 0 &&
      userData.businessDetails.filter((v, i) => {
        return v.primaryUser === true && v.userType === "admin" && v;
      });

    if (tempBusinessDetails && tempBusinessDetails.length > 0) {
      /* console.log("Checkauth 4");
      console.log(
        "tempBusinessDetails.length",
        tempBusinessDetails,
        tempBusinessDetails.length
      ); */
      return {
        user: "admin",
        status: true,
      };
    } else {
      // console.log("Checkauth ELSE 5");

      return {
        user: (userData && userData.userType && userData.userType) || "user",
        status: true,
      };
    }
  }
};

// Storage
export const setStorageItem = (key, value) => {
  storage.setItem(key, value);
};

export const getStorageItem = (key) => {
  try {
    return storage.getItem(key);
  } catch (error) {
    removeAllStorage();
  }
};

export const removeStorageItem = (key) => {
  storage.removeItem(key);
};

export const removeAllStorage = () => {
  storage.clear();
};

// Get auth user data
export const authUserData = () => {
  let userStorageData = getStorageItem("userData");

  if (userStorageData) {
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(userStorageData, "userData");
    var originalText = bytes.toString(CryptoJS.enc.Utf8);

    // console.log("originalText", originalText);
    const userLsData = JSON.parse(originalText);

    console.log("authUserData userLsData", userLsData);
    // let userLsData = JSON.parse(cryptr.decrypt(getStorageItem("userData")));
    // let userLsData = JSON.parse(getStorageItem("userData"));
    return userLsData ? userLsData : null;
  } else {
    return null;
  }
};

// Call authenticated api
export const callAuthApi = () => {
  const token = getStorageItem("accessToken");

  if (token) {
    const decodedToken = jwtDecode(token);
    const today = new Date();

    if (decodedToken.exp < Math.round(today.getTime() / 1000)) {
      removeAllStorage();
      window.location = "/signin";
    } else {
      //console.log(1);
      return api
        .authenticate({
          strategy: "jwt",
          accessToken: token,
        })
        .then((data) => {
          //console.log(2);
          return data && data.accessToken && true;
        })
        .catch((err) => {
          //console.log(3);
          removeAllStorage();
        });
    }
  }
};
